const currencyObj = {
  usd: '$',
  eur: '€',
  ils: '₪',
}

const currencyToSign = currency => currency && currencyObj[currency.trim().toLowerCase()]

export default currencyToSign